// Will also be used for 'space'
const sizes = {
  navigationHeight: "108px",
}

export default sizes
